export const URL_DOGS = '/dogs'
export const URL_DOG = '/dog'
export const URL_TEMPERAMENT = '/temperament'